module.exports = __webpack_public_path__ + "img/Eucalyptus_grandis.4500c26d.jpg";